import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { AppProviders } from './providers/AppProviders'
import { bootstrapNative } from './lib/native/bootstrap'
import './index.css'

// [Native B1] Hydrate the selected instance + its secure-storage credentials before the first
// render, so the request interceptor's sync reads are ready. No-op on web. A storage failure
// still renders: whatever did not hydrate reads as absent, i.e. signed out (never a blank app).
try {
  await bootstrapNative()
} catch {
  // Intentionally silent: no credential or token detail belongs in a log.
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
)
